import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import Spinner from './Spinner'

type IconButtonProps = {
  actionDescription: string
  icon: IconDefinition
  loading?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const IconButton: React.FC<IconButtonProps> = ({ actionDescription, icon, className, loading, ...buttonProps }) => (
  <button
    title={actionDescription}
    aria-label={actionDescription}
    className={clsx(
      [
        'h-6 w-6 rounded-md text-gray-500',
        // Hover
        'hover:text-gray-800',
        // Focus
        'focus:ring-brand-500',
        // Disabled
        'disabled:text-gray-300',
      ],
      className
    )}
    {...buttonProps}
  >
    {loading ? <Spinner className="!mx-auto h-4 w-4" /> : <FontAwesomeIcon className="!mx-auto" icon={icon} />}
  </button>
)

export default IconButton
